import { StoreCustomerReviewItem, StoreCustomerUnreviewedProduct } from '@/types/http';

export const dummyReviewedItems: StoreCustomerReviewItem[] = [
  {
    id: '7401e5c5-05d2-425a-aa46-55a949482fe6',
    product_item_id: '0198f96d-0039-7070-8f1f-c468ba9f6086',
    item_id: '',
    customer_id: '01991a8a-c072-7ad4-8ad9-46446a1fc0a9',
    order_id: '0199c3e8-2159-7323-9469-1b0b746840af',
    rating: 5,
    comment: 'Review dari mobile 🙄',
    created_at: '2025-10-09T11:24:02.638121+08:00',
    updated_at: '2025-10-09T11:24:02.638121+08:00',
    action_by: 'grellylondo@gmail.com',
    customer_name: null,
    item_name: '50ml',
    item_thumbnail_url:
      'https://store-assets.jubelio.com/webstore-v2/images/jstorev2/tjylu79x0uhh7/1756492843777_d9081817-49b6-4cc7-931f-cc370762aee0.png',
    product_name: 'Vetiver Fig (50ml)',
    media: [
      {
        id: 107,
        review_id: '7401e5c5-05d2-425a-aa46-55a949482fe6',
        media_type: 'image',
        media_url:
          'https://store-assets.jubelio.com/webstore-v2/images/1759980234104_66db6af5-9e45-4fb9-a235-5cfff0da827f.jpeg',
        created_at: '2025-10-09T11:24:02.494443+08:00',
      },
    ],
  },
  {
    id: '19c0fe2d-e9ba-4220-b68e-2e1cc72bce72',
    product_item_id: '0198fab6-05c6-7d80-9bac-f0f933476c04',
    customer_id: '01991a8a-c072-7ad4-8ad9-46446a1fc0a9',
    order_id: '0199c20a-314d-7066-8a0a-005b70490182',
    rating: 2,
    item_id: '',
    comment: 'Coba review double dan upload &gt; 3 gambar',
    created_at: '2025-10-09T10:46:44.922225+08:00',
    updated_at: '2025-10-09T10:49:46.077985+08:00',
    action_by: 'j.webv2@gmail.com',
    customer_name: null,
    item_name: '50ml',
    item_thumbnail_url:
      'https://store-assets.jubelio.com/webstore-v2/images/jstorev2/tjylu79x0uhh7/1756492976554_16fa9f71-3103-4faf-a85b-35ab9b2729bd.png',
    product_name: 'Vanille Brûlée (50ml)',
    media: [
      {
        id: 102,
        review_id: '19c0fe2d-e9ba-4220-b68e-2e1cc72bce72',
        media_type: 'image',
        media_url:
          'https://store-assets.jubelio.com/webstore-v2/images/1759977983509_b04c747c-f855-4866-9abd-68e0804c40e4.png',
        created_at: '2025-10-09T10:46:44.861434+08:00',
      },
      {
        id: 103,
        review_id: '19c0fe2d-e9ba-4220-b68e-2e1cc72bce72',
        media_type: 'image',
        media_url:
          'https://store-assets.jubelio.com/webstore-v2/images/1759977986150_c27409e6-b188-4b30-818a-2b5858b09862.png',
        created_at: '2025-10-09T10:46:44.861434+08:00',
      },
      {
        id: 104,
        review_id: '19c0fe2d-e9ba-4220-b68e-2e1cc72bce72',
        media_type: 'image',
        media_url:
          'https://store-assets.jubelio.com/webstore-v2/images/1759977988590_4faac644-0b4b-412a-a7d3-842a6cb890a9.png',
        created_at: '2025-10-09T10:46:44.861434+08:00',
      },
      {
        id: 105,
        review_id: '19c0fe2d-e9ba-4220-b68e-2e1cc72bce72',
        media_type: 'image',
        media_url:
          'https://store-assets.jubelio.com/webstore-v2/images/1759977990622_195b6010-91d9-4b91-99e6-1fae84d493d4.png',
        created_at: '2025-10-09T10:46:44.861434+08:00',
      },
      {
        id: 106,
        review_id: '19c0fe2d-e9ba-4220-b68e-2e1cc72bce72',
        media_type: 'image',
        media_url:
          'https://store-assets.jubelio.com/webstore-v2/images/1759977992232_90f6683c-af85-4bf6-8bf0-eae5baede8fd.png',
        created_at: '2025-10-09T10:46:44.861434+08:00',
      },
    ],
  },
];

export const dummyUnReviewItems: StoreCustomerUnreviewedProduct[] = [
  {
    order_id: '0199c3e8-2159-7323-9469-1b0b746840af',
    order_status: 'done',
    order_created_at: new Date('2025-10-08T12:59:53.897Z'),
    item_id: '0198face-60fb-7390-910d-ab1234ce7ffd',
    item_name: '50ml',
    product_group_id: '0198face-60d1-7787-9755-79992dd1da66',
    product_name: 'Citrus Vetiver',
    product_images: [
      'https://store-assets.jubelio.com/webstore-v2/images/jstorev2/tjylu79x0uhh7/1756554327993_c2d9eb45-21b7-47ef-aebe-4ed1d40636fa.png',
    ],
  },
  {
    order_id: '0199c3e8-2159-7323-9469-1b0b746840af',
    order_status: 'done',
    order_created_at: new Date('2025-10-08T12:59:53.897Z'),
    item_id: '0198fabb-f281-7de9-b5ff-a3e83a36b79d',
    item_name: '50ml',
    product_group_id: '0198fabb-f25f-7222-b038-7c32bc5c33ae',
    product_name: 'Sel de Mer',
    product_images: [
      'https://store-assets.jubelio.com/webstore-v2/images/jstorev2/tjylu79x0uhh7/1759392959995_db5bc070-d319-421f-8476-e30d23ca8026.png',
    ],
  },
  {
    order_id: '0199c3e8-2159-7323-9469-1b0b746840af',
    order_status: 'done',
    order_created_at: new Date('2025-10-08T12:59:53.897Z'),
    item_id: '0198fabe-4661-73fb-b3c7-f18e789e8f72',
    item_name: '50ml',
    product_group_id: '0198fabe-463f-7162-a467-6ae84e89d277',
    product_name: 'Bois Vert',
    product_images: [
      'https://store-assets.jubelio.com/webstore-v2/images/jstorev2/tjylu79x0uhh7/1756493009098_47b52a24-3d8d-4049-b0ab-0950e43b9296.png',
    ],
  },
];

export const dummyProductReview = [
  {
    review_id: '01990807-532e-774c-acd1-df13ba3f3e25',
    customer_name: 'J***** C******',
    attachments: [
      'https://store-assets.jubelio.com/webstore/v2/images/1758797959543_36363874-a4c6-4b5a-b5e5-fbe6fa9083b5.webp',
      'https://store-assets.jubelio.com/webstore/v2/images/1758797967316_16e64e58-29fb-4cb9-9a4e-1bffb1d49aef.webp',
    ],
    created_at: '2025-09-25T10:59:36.365Z',
    descriptions: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque congue.',
    rating: 4,
    variations: {
      label: 'Less Sweet',
      title: 'Variasi',
    },
  },
  {
    review_id: '01990807-532e-774c-acd1-zzzzzzzzzzzz',
    customer_name: 'A***** B******',
    attachments: ['https://store-assets.jubelio.com/webstore/v2/images/1758797991111_sample1.webp'],
    created_at: '2025-09-26T08:20:10.000Z',
    descriptions: 'Great product! The flavor and packaging were perfect.',
    rating: 5,
    variations: {
      label: 'Regular',
      title: 'Variasi',
    },
  },
  {
    review_id: '01990807-532e-774c-acd1-yyyyyyyyyyyy',
    customer_name: 'S***** M******',
    attachments: [],
    created_at: '2025-09-20T14:10:00.000Z',
    descriptions: 'The product arrived in perfect condition. The packaging was also good.',
    rating: 3,
    variations: {
      label: 'Extra Sweet',
      title: 'Variasi',
    },
  },
];
